import { Component, EventEmitter, ViewChild, ViewChildren, ElementRef, HostListener } from '@angular/core';
import { Validators } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';
import { BaseCrudComponent } from 'app/base';

@Component({
    selector: 'trilha-auditoria',
    templateUrl: 'trilha-auditoria-crud.component.html'
})

export class CrudTrilhaAuditoriaComponent extends BaseCrudComponent {

    controllerName = 'trilha-auditoria';

    SistemaOptions: SelectItem[] = [];
    PerfilOptions: SelectItem[] = [];
    FuncionalidadeOptions: SelectItem[] = [];
    listaSistema: any[];
    listaStatus: any[];

    FuncionalidadeSelecionada: string[] = [];

    cadastro = this.formBuilder.group({
        id: [null],
        data_inclusao: [null],
        data_alteracao: [null],
        alterado_por: [null],
        id_status: [null],
        id_finalidade: [null, [Validators.required]],
        id_sistema: [null, [Validators.required]],
        perfil_funcionalidade_acao: [null, [Validators.required]],
        incluido_por: [null]
    });

    init() {
        this.service.ListarTodos('sistema').subscribe(x => {
            this.listaSistema = x;
        });
        this.service.ListarTodos('combo/status').subscribe(x => {
            this.listaStatus = x;
        });

        super.init();
        super.afterLoad();

    }

    afterLoad() {
    }

    finalizar(event: any) {

    }

    voltar() {
        this.location.back();
    }
}


// WEBPACK FOOTER //
// ./src/app/trilha-auditoria/crud/trilha-auditoria-crud.component.ts